export default {
  step (state) {
    return state.step
  },
  questions (state) {
    return state.questions
  },
  question (state) {
    return state.questions[state.step]
  },
  lastStep (state) {
    return state.questions.length === state.step + 1
  },
  nextStep (state) {
    const question = state.questions[state.step]
    if (question === undefined || question.required === false) {
      return true
    } else {
      if (question.type === 'text' || question.type === 'textarea' || question.type === 'date' || question.type === 'select') {
        return question.value !== ''
      } else if (question.type === 'options') {
        return question.value !== null
      } else {
        return question.value.lenght !== 0
      }
    }
  }
}
